<template>
  <section id="RedepositBonus">
    <BottomLine class="title-wrapper">
      <h2 class="title">{{ $t('promotion.redepositBonus.redepositBonus') }}</h2>
    </BottomLine>
    <div class="btn-wrapper">
      <Button @click="activedTab = CONDITION_TAB" v-bind="getStyle(activedTab === CONDITION_TAB)">
        {{ $t('common.campaignCondition') }}
      </Button>
      <Button @click="activedTab = OVERVIEW_TAB" v-bind="getStyle(activedTab === OVERVIEW_TAB)">
        {{ $t('common.statusOverview') }}
      </Button>
    </div>
    <component :is="currentComponent" />
  </section>
</template>

<script>
import BottomLine from '@/components/decorator/BottomLine.vue';
import Button from '@/components/interact/Button.vue';
import CampaignConditions from '@/components/cnDepositBonus/reDepositBonus/CampaignConditions.vue';
import StatusOverview from '@/components/cnDepositBonus/reDepositBonus/StatusOverview.vue';
import { btnStyleConfig } from '@/constants/style';

const CONDITION_TAB = 'condition-tab';
const OVERVIEW_TAB = 'overview-tab';

export default {
  name: 'RedepositBonus',
  components: {
    BottomLine,
    Button,
    CampaignConditions,
    StatusOverview
  },
  data() {
    return {
      CONDITION_TAB,
      OVERVIEW_TAB,
      activedTab: CONDITION_TAB,
      btnStyleConfig,
      isPopOutVisible: true
    };
  },
  methods: {
    getStyle(active) {
      if (active) return btnStyleConfig.BTN_ACTIVE;
      return btnStyleConfig.BTN_DEFAULT;
    }
  },
  computed: {
    currentComponent() {
      return this.activedTab === CONDITION_TAB ? 'CampaignConditions' : 'StatusOverview';
    }
  }
};
</script>

<style lang="scss" scoped>
#RedepositBonus {
  text-align: center;
  position: relative;
  & .title-wrapper {
    margin-top: 59px;
  }

  & .title {
    font-size: 56px;
    font-family: Oblivian, PingFangSC-Medium;
    font-weight: 500;
    color: #000d28;

    @media (max-width: $DEVICE_SIZE_MOBILEL) {
      font-size: 44px;
    }
  }

  & .btn-wrapper {
    margin-top: 69px;
    .el-button {
      &:not(:last-child) {
        @include rtl-sass-prop(margin-right, margin-left, 30px);
      }
    }
  }

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    padding: 0 5px;
  }
}
</style>
